export const FETCH_CLOCKED_IN_STATUS = 'FETCH_CLOCKED_IN_STATUS';
export const FETCH_CLOCKED_HOURS = 'FETCH_CLOCKED_HOURS';
